package ui.new_ui.components.move_up

import emotion.react.css
import react.FC
import react.ReactNode
import react.dom.html.ReactHTML
import ui.new_ui.color_scheme.MainColorScheme
import ui.styles.icons.ArrowDownRoundedIconSVG
import web.cssom.*
import web.scroll.ScrollBehavior
import web.scroll.ScrollToOptions
import web.window.window

val MoveUp = FC {
    ReactHTML.div{
        css {
            zIndex = 1.unsafeCast<ZIndex>()
            width = 40.px
            height = 40.px
            borderRadius = 6.px
            position = Position.fixed
            backgroundColor = MainColorScheme.TertiaryColors.tertiaryColorContainer()
            cursor = Cursor.pointer
            userSelect = None.none

            right = 10.px
            bottom = 10.px
        }

        onClick = {
            window.scrollTo(ScrollToOptions(
                ScrollBehavior.smooth,
                0.0,
                0.0
            ))
        }

        ReactHTML.div{
            css {
                marginTop = 6.px
            }
            ArrowDownRoundedIconSVG.iconSVG{
                this.pl = mapOf(
                    "rotate" to "180",
                    "scale" to "2"
                )
            }
        }
    }
}